import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { SolutionModel, SolutionRequest } from '@generativ/much-smarter-models';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ErrorHandlerService } from '../../../core/services/error-handler.service';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class SolutionService {

  private solutionUrl = environment.msApiUrl + 'solutions/';

  constructor(private http: HttpClient,
              private errorHandlerService: ErrorHandlerService) {
  }

  getSolution(id: number): Observable<SolutionModel> {
    return this.http.get<SolutionModel>(this.solutionUrl + id).pipe(
      catchError(this.errorHandlerService.handleError));
  }

  createSolution(course: SolutionRequest.Create): Observable<SolutionModel> {
    return this.http.post<SolutionModel>(this.solutionUrl, course).pipe(
      catchError(this.errorHandlerService.handleError));
  }

  updateSolution(id: number, solution: SolutionRequest.Update): Observable<SolutionModel> {
    return this.http.patch<SolutionModel>(this.solutionUrl + id, solution).pipe(
      catchError(this.errorHandlerService.handleError));
  }
}
